import { analyticsApi } from 'src/services/analyticsApi'

export interface UploadAvatarResponse {
  data?: {
    avatarUrl?: string
  }
  success?: boolean
}

export const uploadUserAvatar = async (
  file: File
): Promise<UploadAvatarResponse> => {
  const formData = new FormData()
  formData.append('avatar', file)

  const { data } = await analyticsApi().post<UploadAvatarResponse>(
    '/v1_private/user-features/avatar',
    formData
  )

  return data
}

export const deleteUserAvatar = async (): Promise<void> => {
  await analyticsApi().delete('/v1_private/user-features/avatar')
}

export interface UpdateProfileParams {
  country?: string
}

export const updateUserProfile = async (
  params: UpdateProfileParams
): Promise<void> => {
  await analyticsApi().post('/v1_private/user-features/profile', params)
}
